import React, { Component } from 'react';
import './App.css';
// import './styles/Light.css'
import Routes from './skeleton/Routes';
import LocalStorage from './providers/LocalStorage';
import ReactDOM from 'react-dom';
import AlertDialog from './commons/dialogs/AlertDialog';
import SpecificComponent from './commons/SpecificComponent';



class App extends Component {

  constructor(props){
 
    super(props);
    this.state = {
        isOpenAlert:false,
        timer:3000
        
    } 

   
}



  componentWillMount(){
   // this.getTheme()
  

  
   
  }

  componentDidMount(){

    this.inactivityTime()

  }
  
inactivityTime = () => {

  this.setTimer()
  window.addEventListener('mousemove',this.clearTimer) 
  window.addEventListener('onkeypress',this.clearTimer)
  
    window.onload = this.clearTimer();
    // DOM Events
  
  

 
};

setTimer = () =>{
  if(this.timerHandler){
    return true;
    }

    this.timerHandler = setTimeout(()=>{
      this.setState({isOpenAlert:true})
      this.timerHandler = 0
    }, 1.8e+6)
}

  clearTimer = () =>{
    // console.log('moveMouse :');
    if(this.timerHandler){
      clearTimeout(this.timerHandler)
      this.timerHandler = 0
      this.setTimer()
    }
  
}

// getTheme = () =>{
//         console.log('changeTheme :');
    
//         let ls = new LocalStorage();
    
//         let theme = ls.GetUserPreferences().theme

       
    
//         if(theme === 'dark'){
//            require('./styles/Dark.css')
    
    
//         }else if(theme === 'light'){
//          require( './styles/Light.css');
        
//         }
//     }

  render() {
    return (
      <div>
        <AlertDialog
          open={this.state.isOpenAlert}
          dialogClose={()=>{this.setState({isOpenAlert:false},()=>{this.setTimer()})}}
          title={'S-a detectat o inactivitate mai mare de 30 de minute !'}
          limba={new SpecificComponent().dictionary}
          noButtonDisplay={1}
          yesFunction={()=>{this.setState({isOpenAlert:false},()=>{this.setTimer()})}}
          />
          <Routes />
      </div>
     
    );
  }
}

export default App;


ReactDOM.render(<App/>, document.getElementById('root'))
